import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
window.bootstrap = bootstrap;

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

import NiceSelect from "nice-select2";

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

document.addEventListener("DOMContentLoaded", () => {
  // Initialize the datetime picker for all elements with class 'datetime-picker'
  flatpickr(".datetime-picker", {
    enableTime: false, // Enable time selection
    dateFormat: "Y-m-d H:i", // Set date and time format
    minuteIncrement: 1, // Allow minute selection with 1-minute increments
  });

  // Initialize the time picker for all elements with class 'time-picker'
  flatpickr(".time-picker", {
    enableTime: true, // Enable time selection only
    noCalendar: true, // Disable calendar (only time will be shown)
    dateFormat: "H:i", // Set time format (24-hour format)
    minuteIncrement: 1, // Allow minute selection with 1-minute increments
  });
});

// rating funcionality

document.addEventListener("DOMContentLoaded", function () {
  const ratingContainer = document.getElementById("rating");
  if (!ratingContainer) return; // Check if the rating container exists

  const stars = ratingContainer.querySelectorAll("i");
  if (ratingContainer.dataset.initialized) return; // Prevent reinitialization if already initialized

  ratingContainer.dataset.initialized = "true";

  function updateRating(rating) {
    stars.forEach((star) => {
      const starIndex = parseInt(star.getAttribute("data-index"), 10);
      if (starIndex <= rating) {
        star.classList.add("icon-star");
        star.classList.remove("icon-star-o");
      } else {
        star.classList.remove("icon-star");
        star.classList.add("icon-star-o");
      }
    });
  }

  stars.forEach((star) => {
    star.addEventListener("click", function () {
      const rating = parseInt(star.getAttribute("data-index"), 10);
      updateRating(rating);
      console.log("Selected rating: " + rating); // Optional: Save or process the rating
    });
  });

  updateRating(0);
});

// pincode function

document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll(".pincode-input-text");

  if (inputs && inputs.length > 0) {
    inputs.forEach((input, index) => {
      input.addEventListener("input", function (e) {
        if (input.value.length === 1 && index < inputs.length - 1) {
          const nextInput = inputs[index + 1];

          if (nextInput) {
            nextInput.focus();
          }
        }
      });
    });
  }
});

// dropdown with checkboxes

document.addEventListener("DOMContentLoaded", function () {
  const servicesDropdown = document.querySelector(
    ".o-booking-options__services-dropdown"
  );
  if (!servicesDropdown) return;

  const checkboxes = servicesDropdown.querySelectorAll(".btn-check");
  const selectionDiv = document.querySelector(".o-booking-options__selection");
  const selectedData = []; // To store selected data

  if (!selectionDiv) return;

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        const tag = document.createElement("span");
        tag.classList.add("badge", "bg-tertiary", "text-primary", "m-2");
        tag.textContent = checkbox.nextElementSibling.textContent;

        const checkIcon = document.createElement("i");
        checkIcon.classList.add("icon-check1", "ms-2");
        checkIcon.addEventListener("click", function () {
          tag.remove();
          checkbox.checked = false;
          removeData(checkbox.nextElementSibling.textContent); // Remove from selected data
        });

        tag.appendChild(checkIcon);
        selectionDiv.appendChild(tag);

        // Add the label text to the selectedData array
        addData(checkbox.nextElementSibling.textContent);
      } else {
        const tags = selectionDiv.querySelectorAll("span");
        tags.forEach((tag) => {
          if (tag.textContent === checkbox.nextElementSibling.textContent) {
            tag.remove();
            removeData(checkbox.nextElementSibling.textContent);
          }
        });
      }
    });
  });

  // Function to add data to the selectedData array
  function addData(label) {
    if (!selectedData.includes(label)) {
      selectedData.push(label);
    }
  }

  // Function to remove data from the selectedData array
  function removeData(label) {
    const index = selectedData.indexOf(label);
    if (index !== -1) {
      selectedData.splice(index, 1);
    }
  }

  // Example: Logging the selected data to the console when you want to access it
  const getSelectedDataButton = document.querySelector("#get-selected-data");
  if (getSelectedDataButton) {
    getSelectedDataButton.addEventListener("click", function () {
      console.log("Selected Options:", selectedData);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const openGallery = document.getElementById("open-gallery");

  if (openGallery) {
    openGallery.addEventListener("click", function () {
      const galleryItems = document.querySelectorAll(
        '.main-slider-container img[data-fancybox="gallery"]'
      );

      if (galleryItems.length > 0) {
        Fancybox.show(
          Array.from(galleryItems).map((img) => ({
            src: img.src,
            caption: img.alt,
          })),
          {
            Thumbs: {
              autoStart: true,
            },
            loop: true,
          }
        );
      }
    });
  }
});

// swiper slider init

const swiperContainer = document.querySelector(".swiper-container");

if (swiperContainer) {
  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 1.2, // Show 4 slides
    spaceBetween: 32, // Space between slides
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      992: {
        slidesPerView: 3.3,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next", // Next button selector
      prevEl: ".swiper-button-prev", // Prev button selector
    },
    pagination: {
      el: ".swiper-pagination", // Pagination element selector
      clickable: true, // Enable clickable pagination
    },
    loop: true, // Optional: Enable loop for infinite scrolling
  });
}

const swiperContainerRecommended = document.querySelector(
  ".swiper-container-recommended"
);

if (swiperContainerRecommended) {
  const swiper = new Swiper(swiperContainerRecommended, {
    slidesPerView: 1.2, // Show 4 slides
    spaceBetween: 24, // Space between slides
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 3.3,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next", // Next button selector
      prevEl: ".swiper-button-prev", // Prev button selector
    },
    pagination: {
      el: ".swiper-pagination", // Pagination element selector
      clickable: true, // Enable clickable pagination
    },
    loop: true, // Optional: Enable loop for infinite scrolling
  });
}

const swiperContainerDuo = document.querySelector(".swiper-container-duo");

if (swiperContainerDuo) {
  const swiper = new Swiper(swiperContainerDuo, {
    slidesPerView: 1, // Show 4 slides
    spaceBetween: 24, // Space between slides
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 24,
      },
      1100: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next", // Next button selector
      prevEl: ".swiper-button-prev", // Prev button selector
    },
    pagination: {
      el: ".swiper-pagination", // Pagination element selector
      clickable: true, // Enable clickable pagination
    },
    loop: true, // Optional: Enable loop for infinite scrolling
  });
}

// enable tooltips

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
);

// custom select color change

document.addEventListener("DOMContentLoaded", () => {
  const selects = document.querySelectorAll("select.nice-select");
  selects.forEach((select) => {
    new NiceSelect(select);
  });
});

// autocomplete search

document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById("autocomplete-search");
  const resultsContainer = document.getElementById("autocomplete-results");

  // Check if both elements exist before proceeding
  if (!searchInput || !resultsContainer) {
    return; // Exit the function if these elements are not present on the page
  }

  const dummySuggestions = [
    "Apple",
    "Banana",
    "Orange",
    "Pineapple",
    "Strawberry",
    "Grapes",
    "Blueberry",
    "Watermelon",
    "Peach",
    "Mango",
  ];

  searchInput.addEventListener("input", () => {
    const query = searchInput.value.toLowerCase();
    const suggestions = query
      ? dummySuggestions.filter((item) => item.toLowerCase().includes(query))
      : [];

    resultsContainer.innerHTML = suggestions
      .map((s) => `<li>${s}</li>`)
      .join("");
    resultsContainer.style.display = suggestions.length ? "block" : "none";

    resultsContainer.querySelectorAll("li").forEach((li) => {
      li.addEventListener("click", () => {
        searchInput.value = li.textContent;
        resultsContainer.style.display = "none";
      });
    });
  });

  document.addEventListener("click", (e) => {
    if (!resultsContainer.contains(e.target) && e.target !== searchInput) {
      resultsContainer.style.display = "none";
    }
  });
});

// add to favourite function

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".m-product-item__add-to-fav").forEach((button) => {
    if (
      button.querySelector(".icon-heart-o") &&
      button.querySelector(".icon-heart")
    ) {
      button.addEventListener("click", () => {
        const isFavorited = button.dataset.addedToFav === "true";
        button.dataset.addedToFav = isFavorited ? "false" : "true";
        button
          .querySelector(".icon-heart-o")
          .classList.toggle("hidden", !isFavorited);
        button
          .querySelector(".icon-heart")
          .classList.toggle("hidden", isFavorited);
      });
    }
  });
});

// image gallery on hover

document.addEventListener("DOMContentLoaded", () => {
  // Find all galleries with the class .m-product-item__gallery
  const galleries = document.querySelectorAll(".m-product-item__gallery");

  galleries.forEach((gallery) => {
    const images = gallery.querySelectorAll(".gallery-image"); // Select images within the gallery
    let currentIndex = 0;
    let interval;

    // Fade-in effect on mouseover
    gallery.addEventListener("mouseover", () => {
      // Reset all images' opacity to 0
      images.forEach((img, index) => (img.style.opacity = 0));

      // Fade in images one by one with a delay
      images.forEach((img, index) => {
        setTimeout(() => {
          img.style.opacity = 1; // Fade in image
        }, index * 500); // Apply delay based on index
      });

      // Start the infinite loop of fading images every 3 seconds
      interval = setInterval(() => {
        images.forEach((img, index) => (img.style.opacity = 0)); // Reset opacity
        images[currentIndex].style.opacity = 1; // Show the current image
        currentIndex = (currentIndex + 1) % images.length; // Move to the next image, loop back to 0 after the last image
      }, 2000); // 3 seconds interval for infinite loop
    });

    // Reset images when mouse leaves
    gallery.addEventListener("mouseout", () => {
      clearInterval(interval); // Stop the infinite loop
      images.forEach((img, index) => (img.style.opacity = 0)); // Reset opacity to 0
      images[0].style.opacity = 1; // Ensure the first image is visible
      currentIndex = 0; // Reset to the first image
    });
  });
});

// list info hover effect

const highlights = document.querySelectorAll(".m-product-item__highlights");

highlights.forEach((highlight) => {
  // Find the closest '.m-product-item' parent and get the '.m-product-item__list-info' inside the '.m-product-item__details' child
  const listInfo = highlight
    .closest(".m-product-item")
    .querySelector(".m-product-item__list-info");

  listInfo.style.opacity = "0";
  listInfo.style.pointerEvents = "none";

  highlight.addEventListener("mouseover", () => {
    listInfo.style.opacity = "1";
    listInfo.style.pointerEvents = "all";
  });

  highlight.addEventListener("mouseout", () => {
    listInfo.style.opacity = "0";
    listInfo.style.pointerEvents = "none";
  });
});

// Check if the main slider exists before initializing
const mainSliderContainer = document.querySelector(".main-slider-container");
const thumbnailSliderContainer = document.querySelector(
  ".thumbnail-swiper-container"
);

if (mainSliderContainer && thumbnailSliderContainer) {
  // Initialize the main slider
  const mainSlider = new Swiper(mainSliderContainer, {
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true, // Keep main slider as non-centered
    loop: true,
    slideToClickedSlide: true,
    watchOverflow: false,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Initialize the thumbnail slider
  const thumbnailSlider = new Swiper(thumbnailSliderContainer, {
    slidesPerView: 5, // Show 5 thumbnails by default
    spaceBetween: 0, // No space between thumbnails
    slideToClickedSlide: true, // Make the clicked thumbnail slide to the main slider
    freeMode: false, // Disable free mode (keep snapping behavior)
    centeredSlides: true, // Keep thumbnails aligned to the left (not centered)
    loop: true, // Prevent looping of thumbnails
    watchOverflow: false, // Avoid adjustments based on slide count
    breakpoints: {
      640: {
        slidesPerView: 3, // Show 3 thumbnails on small screens
      },
      768: {
        slidesPerView: 5, // Show 5 thumbnails on larger screens
      },
    },
  });

  // Sync thumbnail slider with main slider
  mainSlider.controller.control = thumbnailSlider;
  thumbnailSlider.controller.control = mainSlider;
}

// filter search template

const categoryItems = document.querySelectorAll(
  ".o-search__filters__category-item"
);
const clearButton = document.getElementById("clear-all-btn");

if (categoryItems) {
  categoryItems.forEach((item) => {
    item.addEventListener("click", () => {
      const index = item.getAttribute("data-index");
      const targetResult = document.querySelector(
        `.o-search__filters__results-item[data-index="${index}"]`
      );

      if (targetResult) {
        const allResults = document.querySelectorAll(
          ".o-search__filters__results-item"
        );
        if (allResults) {
          allResults.forEach((result) => {
            result.style.display = "none";
          });
          targetResult.style.display = "block";
        }
      }

      categoryItems.forEach((category) => {
        category.classList.remove("active");
      });
      item.classList.add("active");
    });
  });
}

if (clearButton) {
  clearButton.addEventListener("click", () => {
    const checkboxes = document.querySelectorAll(
      '.o-search__filters__body input[type="checkbox"]'
    );
    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }

    const allResults = document.querySelectorAll(
      ".o-search__filters__results-item"
    );
    if (allResults) {
      allResults.forEach((result) => {
        result.style.display = "block";
      });
    }

    categoryItems.forEach((category) => {
      category.classList.remove("active");
    });

    const defaultCategory = document.querySelector(
      '.o-search__filters__category-item[data-index="location"]'
    );
    if (defaultCategory) {
      defaultCategory.click();
    }
  });
}

const defaultCategory = document.querySelector(
  '.o-search__filters__category-item[data-index="location"]'
);
if (defaultCategory) {
  defaultCategory.click();
}

// select filter product

var searchProductPage = document.getElementById("search-product-page");
if (searchProductPage) {
  searchProductPage.addEventListener("change", function () {
    var selectedOption = this.options[this.selectedIndex];
    var selectedName = selectedOption.getAttribute("name");
    var selectedValue = selectedOption.value;

    if (selectedName !== "Search by Name" && selectedValue) {
      window.location.href = selectedValue;
    }
  });
}

/// header mobile js

document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.querySelector(".o-header__hamburger");
  const headerMain = document.querySelector(".o-header__main");
  const body = document.body;

  if (hamburger && headerMain) {
    hamburger.addEventListener("click", () => {
      headerMain.classList.toggle("active--state");

      hamburger.classList.toggle("active--state");

      // Toggle .menu-open on body
      body.classList.toggle("menu-open");
    });
  }
});
